import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import type { ConditionAttribute } from 'types/helios/templateForms';
import { findTemplateSectionIndex } from '../utils/nameUniqueness';

export interface Payload {
  name: string;
  layoutType: LayoutType;
  conditions: ConditionAttribute[];
  tabId?: string | null;
}

export const setSectionConditions = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, layoutType, conditions, tabId } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = findTemplateSectionIndex(sections, name, tabId);

  if (sectionIndex !== -1) {
    state[layoutType].sections[sectionIndex].defaultConditionAttributes = conditions;
  }
};
